import CloseIcon from '@mui/icons-material/Close';
import { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { useSidePanelDispatch } from '@legacy/components/layout/SidePanel';
import {
  IconButton,
  Stack,
  Typography,
} from '@legacy/components/mui-components';
import styles from './Header.module.scss';

interface IHeader {
  activateSidePanelButtonRef?: RefObject<HTMLButtonElement | null>;
}

export const Header = ({ activateSidePanelButtonRef }: IHeader) => {
  const dispatch = useSidePanelDispatch();
  const { t } = useTranslation('filter');

  return (
    <Stack
      className={styles.title}
      data-automation-id="FilterTitle"
      direction="row"
      alignItems="center"
      justifyContent="space-between"
    >
      <Typography
        fontWeight={500}
        component="h2"
        variant="h2"
        data-automation-id="SidePanelHeading"
      >
        {t('FilterPanelHeading')}
      </Typography>
      <IconButton
        data-automation-id="SidePanelCloseBtn"
        title={t('FilterPanelCloseButton')}
        onClick={() => {
          dispatch?.({ type: 'CLOSE_PANEL' });
          activateSidePanelButtonRef?.current?.focus();
        }}
      >
        <CloseIcon />
      </IconButton>
    </Stack>
  );
};
